import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FormikSelectTwo from "../../../utils/Select";
import * as yup from "yup";
import { moduleList, statusList } from "../../../assets/data/CountryMini";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [createNew, setCreateNew] = useState({
    module_id: "",
    status_name: "",
  });

  useEffect(() => {
    setCreateNew({
      module_id: data?.module_id,
      status_name: data?.status_type,
    });
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      module_id: yup.string().required("select is required"),
      status_name: yup.string().required("status is rquierd"),
    }),
    onSubmit: (value, { resetForm }) => {
      if (data?.id) {
        value.status_type = value.status_name.toLowerCase();
        editData({
          url: `/Status/${data?.id}/`,
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      } else {
        addData({
          url: `/Status/`,
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      }
    },
  });

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-30 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <FormikSelectTwo
                formik={formik}
                name="module_id"
                label="Module"
                width="w-full"
                placeholder="Select Module"
                Options={moduleList}
                zindex={12}
                isDisabled={data ? true : false}
              />
              <FormikSelectTwo
                formik={formik}
                name="status_name"
                label="Status"
                width="w-full"
                placeholder="Select Status"
                Options={statusList}
                zindex={12}
              />
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
